
export const interactiveData = {
  polls: {
    details: {
      title: "Szavazás részletei",
      period: "Időszak",
      status: "Állapot",
      active: "Aktív",
      closed: "Lezárt",
      exportVoters: "Szavazók exportálása",
      closePoll: "Szavazás lezárása",
      successClosed: "Szavazás sikeresen lezárva!",
      errorClosing: "Hiba történt a szavazás lezárása közben",
      results: "Eredmények",
      voters: "Szavazók",
      tableHeaders: {
        option: "Lehetőség",
        votes: "Szavazatok száma",
        percentage: "Százalék",
        name: "Név",
        email: "Email",
        date: "Dátum",
        answer: "Válasz"
      },
      chart: {
        votes: "Szavazatok",
        option: "Lehetőség"
      }
    }
  },
  title: "Interaktív adatok",
  participants: "Résztvevők",
  date: "Dátum",
  status: "Állapot",
  active: "Aktív",
  closed: "Lezárva",
  votes: "Szavazatok",
  subscribers: "Feliratkozók",
  discount: "Kedvezmény",
  clicks: "Kattintások",
  subscriptions: {
    title: "Feliratkozások adatai",
    description: "A feliratkozások áttekintése és kezelése"
  },
  promoCodes: {
    title: "Promóciós kódok adatai",
    description: "A promóciós kódok áttekintése és kezelése"
  },
  links: {
    title: "Linkek adatai",
    description: "A linkek áttekintése és kezelése"
  }
};
